export const Circle = {
    LOADING_CIRCLE: "LOADING_CIRCLE",
    GET_CIRCLE: "GET_CIRCLE",
  };